<template>
  <div id="app" class="position-reltive h-100 overflow-scroll" >
    <b-navbar toggleable="sm" variant="primary" type="dark" class="shadow-sm" sticky>
      <b-navbar-brand to="/">CAP</b-navbar-brand>
       <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav >
      <b-navbar-nav>
        <b-nav-item active-class="active font-weight-bold" to="home">Home</b-nav-item>
        <b-nav-item active-class="active font-weight-bold" to="capture">Capture</b-nav-item>
        <b-nav-item active-class="active font-weight-bold" to="upload">Upload</b-nav-item>
        <b-nav-item active-class="active font-weight-bold" to="process">Process</b-nav-item>
        <b-nav-item active-class="active font-weight-bold" to="download">Download</b-nav-item>
      </b-navbar-nav>

      
      
      <b-navbar-nav class="ml-auto">
        <img src="logo-cine-mg-background-with-tag.png" style="width:50px;" />
      
        <b-nav-item-dd right>
          <template v-slot:button-content>
            <span v-if="$api.is('logged_in')">
              <em v-if="!$api.is('local_user')">{{$api.userdata.group}}:</em>{{$api.userdata.user}}
            </span>
            <span v-else-if="$api.is('logged_out')" class="text-light">Sign In</span>
            <span v-else-if="$api.is('pending')" class="text-light">...</span>
          </template>
          <b-dd-item v-if="$api.is('administrator')" :href="$api.managementURL()">Management</b-dd-item>
          <b-dd-item v-if="$api.is('local_user')" :href="$api.resetPassword()">Reset password</b-dd-item>
          <b-dd-item v-if="$api.is('logged_in') " :href="$api.logout()">Sign out</b-dd-item>
          <b-dd-item v-if="$api.is('logged_out')" :href="$api.createAccount()">Create account</b-dd-item>
          <b-dd-item v-if="$api.is('logged_out')" :href="$api.login()">Sign in</b-dd-item>
        </b-nav-item-dd>
      </b-navbar-nav>
        
    </b-collapse>
    </b-navbar>

    <router-view></router-view>

    <!-- Footer -->
  <mdb-footer color="blue" class="font-small pt-4 mt-4">
    <mdb-container class="text-right">
      <mdb-row>
        <mdb-col sm="6">
          
        </mdb-col>
        <mdb-col sm="6">
          
        </mdb-col>
      </mdb-row>
    </mdb-container>
    <div class="footer-copyright text-center py-3">
      <mdb-container fluid>
        <img src="cine logo + npa.png" style="height:10vh;" />
      </mdb-container>
    </div>
  </mdb-footer>
  <!-- Footer -->
    
    </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.min.css';
import Vue from 'vue'
import * as bs from 'bootstrap-vue'

[
    bs.NavbarPlugin,
    bs.DropdownPlugin,
    bs.LayoutPlugin,
].forEach(p => Vue.use(p));
export default {
  name: 'app',
}
</script>  

<style>
@import url(https://fonts.googleapis.com/css?family=Source+Sans+Pro:600);

#app {
    font-family: 'Source Sans Pro', sans-serif; 
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale; 
    text-align: center;
}
.bg-primary {
    background-color: #1a9bd7 !important;
}
a {
    color: #1a9bd7;
    }
</style>
